import request from '@/utils/request'


// 查询用户信息列表
export function listUser(query) {
  return request({
    url: '/biz/app-feedbacks/users/list',
    method: 'get',
    params: query
  })
}

// 查询用户信息分页
// export function pageUser(query) {
//   return request({
//     url: '/biz/app-feedbacks/users/page',
//     method: 'get',
//     params: query
//   })
// }
export function pageUser(query) {
  return request({
    url: '/account/accounts/pageDistributionInfo',
    method: 'get',
    params: query
  })
}

export function updateVipTime(data) {
  return request({
    url: '/biz/app-feedbacks/users/updateVipTime',
    method: 'post',
    data: data
  })
}

// 查询用户信息详细
export function getUser(data) {
  return request({
    url: '/biz/app-feedbacks/users/detail',
    method: 'get',
    params: data
  })
}

// 新增用户信息
export function addUser(data) {
  return request({
    url: '/biz/app-feedbacks/users/add',
    method: 'post',
    data: data
  })
}

// 修改用户信息
export function updateUser(data) {
  return request({
    url: '/biz/app-feedbacks/users/edit',
    method: 'post',
    data: data
  })
}

// 删除用户信息
export function delUser(data) {
  return request({
    url: '/biz/app-feedbacks/users/delete',
    method: 'post',
    data: data
  })
}


export function editLevel(data) {
  return request({
    url: '/biz/user-cancels/editLevel',
    method: 'post',
    data: data
  })
}

export function editDiamond(data) {
  return request({
    url: '/biz/app-feedbacks/editDiamond',
    method: 'post',
    data: data
  })
}



export function editVipTime(data) {
  return request({
    url: '/biz/app-feedbacks/editVipTime',
    method: 'post',
    data: data
  })
}




//
// // 统计（机构/门店）
// export function getALLCollectByEcharts (query) {
//   return request({
//     url: '/platform/platform-institution/getALLCollectByEcharts',
//     method: 'get',
//     params: query
//   })
// }
//
// // 统计（用户总数量/日增数量）
// export function getALLAppUserByEcharts (query) {
//   return request({
//     url: '/platform/platform-institution/getALLAppUserByEcharts',
//     method: 'get',
//     params: query
//   })
// }
//
// // 统计（设备总数量/日增数量）
// export function getALLDeviceByEcharts (query) {
//   return request({
//     url: '/platform/platform-institution/getALLDeviceByEcharts',
//     method: 'get',
//     params: query
//   })
// }
